function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M367.685+340.961L377.945+322.878L373.458+273.449L389.697+232.012L380.693+169.432L367.168+151.985L367.806+93.9634L353.141+65.2712L331.143+70.3721L307.849+95.9368L279.892+94.7612L250.227+98.1758L202.208+94.7612L115.861+96.0273L96.0712+98.7604L41.9583+96.2131L36.8942+304.6L41.3196+346.632L61.8388+348.172L111.081+358.708L114.808+374.187L202.52+380.206L205.673+367.021L237.108+374.205L279.362+365.799L281.125+356.783L306.12+360.929L353.007+355.269L353.644+346.928L367.685+340.961Z",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M50.314+50.3833L27.7789+27.3417L14.3591+38.9891L13.0931+374.484L30.0577+371.699L49.3012+353.974L52.3396+219.27L50.5672+208.382L53.6057+61.7774L50.314+50.3833Z",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M319.043+314.034L308.382+304.066L54.8729+304.995",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M342.055+338.438L323.102+318.263",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M204.834+358.669L202.819+347.08L196.585+342.626L131.168+334.958L115.987+352.336",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M295.021+324.438L269.88+327.486L267.213+333.771L278.788+351.848",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M308.894+297.207L308.812+246.709L305.781+242.309L308.812+230.563L308.894+119.406",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M341.776+264.683L337.734+256.508",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M104.076+240.752L117.44+234.701",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M231.139+237.191L234.903+231.101",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M167.174+325.688L176.296+321.358L229.968+319.568L239.281+325.422",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M64.1208+342.742L82.5565+345.721",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

function SvgLeftA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftA);
export default __webpack_public_path__ + "static/media/left-a.a6a229d5.svg";
export { ForwardRef as ReactComponent };